import { atom } from "recoil"

// Lives here (not in the Panel component) so state modules can subscribe to
// drag status without importing the Studio component tree, which would create
// a circular import back into the elements barrel.
export const panelBeingDraggedState = atom<string | null>({
  key: `panelBeingDraggedState`,
  default: null,
})
